import React, { Component } from 'react'
import './index.less'
import { jumpToUser, jumpToRoom } from 'src/helper/webviewFun'

/**
 * @param {number} scaleSize 整体头像大小
 * @param {string} headWear 头像框（图片地址）
 * @param {string} userAvatar 用户头像（图片地址）
 * @author: KK
 * @desc: 头像模块封装
 */

export default class extends Component {
  constructor(props) {
    super(props)
  }
  jumpTo(userId) {
    if (this.props.userOrRoom == "user") {
      jumpToUser(userId)
    } else if (this.props.userOrRoom == "room") {
      jumpToRoom(userId)
    }
  }
  render() {
    const { scaleSize, headWear, userAvatar, userId } = this.props
    return (
      <div className="kk-avatar-wrap" style={{ transform: `scale(${scaleSize || '1'})` }}>
        <div className="kk-avatar-box">
          <img className='ava' src={userAvatar || ''} />
          <div
            onClick={() => this.jumpTo(userId)}
            className="head-wear" style={{ backgroundImage: `url(${headWear || ''})` }}></div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/component/Header/index.js